module.exports = function getResource(label, vars = []) {
    const resources = {
        colorIQHistoryTitle: 'Vos valeurs Color IQ enregistrées',
        colorIQHistoryDesc: 'Vos valeurs Color IQ capturées dans l’Explorateur de teinte ou balayées en magasin.',
        latest: 'dernier',
        captured: 'Capturé',
        gotIt: 'Compris'
    };

    return resources[label];
};
